var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.335528 9.10406L1.41053 8.57906C3.22961 12.2099 5.51382 15.5883 8.20553 18.6291L8.20553 0.249061L9.40553 0.249061L9.40553 18.5791C12.0012 15.4763 14.2871 12.127 16.2305 8.57906L17.2905 9.11906C15.1515 13.0325 12.6058 16.7095 9.69553 20.0891L9.52053 20.2891L8.11053 20.2891L7.93553 20.1091C4.8859 16.8255 2.32618 13.119 0.335528 9.10406Z",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7479c4850dbd87e378efdce557a99328.svg";
export { ForwardRef as ReactComponent };